// PageInvoiceTemplate Component
/* eslint indent: 0 */

import React from 'react'
import _ from 'lodash'

import util from '../../../lib/util.jsx'
import app from '../../../app.jsx'
import eventfilters from '../../../lib/eventfilters.jsx'
import PageBase from '../../../common/page/page_base/page_base.jsx'
import DialogInvoiceTemplate from '../../dialog/dialog_invoicetemplate/dialog_invoicetemplate.jsx'
import InvoiceTemplateItem from '../../invoicetemplate/invoicetemplate_item/invoicetemplate_item.jsx'
import DialogSetting from '../../../contact/dialog/dialog_setting/dialog_setting.jsx'
import Button from '../../../common/common/button/button.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'
import Grid from '../../../common/common/grid/grid.jsx'
import DialogTemplateMailSetting from '../../../invoice/dialog/dialog_templatemailsetting/dialog_templatemailsetting.jsx'
import IntlUtil from '../../../lib/intlutil.jsx'
import ContentMessage from '../../../common/common/content_message/content_message.jsx'
import ConfirmDelete from '../../../common/common/confirm_delete/confirm_delete.jsx'
import PopupCompanyProfileData from '../../../common/popup/popup_companyprofile_data/popup_companyprofile_data.jsx'
import PageHeader from '../../../theme/layout/page_header/page_header.jsx'
import InvoiceUtil from '../../../lib/invoiceutil.js'
import { InvoicesIcon } from '../../../common/layout/menu_icons/invoices.jsx'

class PageInvoiceTemplate extends PageBase {
  constructor (props) {
    super(props, 'invoice-template', 'invoices', 'invoice-template')

    this.state = {
      isLoading: true,
      dataDate: null,
      pageNo: 1,
      showDataAlert: true
    }

    this.data = {
      invoiceTemplates: [],
      stat: null,
      total: 0,
      countLoaded: 0,
      canPaginate: true,
      pageNo: 1,
      currTemplate: null,
      showSettings: false,
      pageState: {
        type: 'grid',
        sort: 'nextRecurringDate',
        sortAsc: true,
        filter: null
      },
      companyFields: []
    }

    this._bUnMounted = false

    this._setFABButtonState(true, false)
    this._setFABButtonVisible(true)
    this._references = {
      refdialogMailSetting: React.createRef(),
      refHeaderInvoiceTemplate: React.createRef(),
      templateSettingDialog: React.createRef(),
      dialogInvoiceTemplate: React.createRef(),
      confirmStop: React.createRef(),
      popupcompanyprofiledata: React.createRef()
    }
  }

  componentDidMount () {
    document.body.addEventListener('keydown', this._handleDocumentKeyDown)
    this._getData(false)
    this._initEvents()
  }

  componentWillUnmount () {
    document.body.removeEventListener('keydown', this._handleDocumentKeyDown)
    this._bUnMounted = true
    this._releaseEvents()
  }

  componentDidUpdate () {
    this._triggerSettingsDialog()
  }

  _handleDocumentKeyDown = evt => {
    if (
      this.ignoreAutoSearch ||
      (this._references.refdialogMailSetting.current &&
        this._references.refdialogMailSetting.current.isActive()) ||
      (this._references.templateSettingDialog.current &&
        this._references.templateSettingDialog.current.isActive()) ||
      (this._references.dialogInvoiceTemplate.current &&
        this._references.dialogInvoiceTemplate.current.isActive()) ||
      (this._references.popupcompanyprofiledata.current &&
        this._references.popupcompanyprofiledata.current.isActive())
    ) {
      return
    }

    if (this._references.refHeaderInvoiceTemplate.current) {
      const keyCode = evt.keyCode || 0

      let bSearch = true
      if (
        keyCode === 13 ||
        keyCode === 9 ||
        keyCode === 27 ||
        keyCode === 17 ||
        keyCode === 224
      ) {
        bSearch = false
      } else if (evt.ctrlKey || evt.altKey || evt.shiftKey || evt.metaKey) {
        bSearch = false
      }

      if (keyCode === 27) {
        this._references.refHeaderInvoiceTemplate.current.onEscKeyDown()
      } else if (
        bSearch &&
        this._references.refHeaderInvoiceTemplate.current &&
        this._references.refHeaderInvoiceTemplate.current.canShowSearch()
      ) {
        this._references.refHeaderInvoiceTemplate.current.showSearch()
      }
    }
  }

  renderContent () {
    return (
      <div className='pageinnercont'>
        {this._renderMessage()}
        {this._renderGridOrList()}
        {this._renderSettingsDialog()}
        <DialogInvoiceTemplate
          ref={this._references.dialogInvoiceTemplate}
          isQuickbookConnected={app.isQuickbookConnected()}
          getProjects={InvoiceUtil.getProjects}
          contactSearch={this._onSearchContact.bind(this)}
          onSubmit={this._onAddTemplateInvoice.bind(this)}
          onDelete={this._onDelete.bind(this)}
          onClose={this._onCloseDialog.bind(this)}
        />
        <DialogTemplateMailSetting
          ref={this._references.refdialogMailSetting}
          isQuickbookConnected={app.isQuickbookConnected()}
          onSubmit={this._onSubmitMail.bind(this)}
          showWithoutContext={false}
          mailSuggestions={this.data.emailSuggestions}
          showMultiAttachments
          onClose={this._onCloseDialog.bind(this)}
        />
        <PopupCompanyProfileData
          ref={this._references.popupcompanyprofiledata}
          companyData={this.data.companyFields}
          onClick={this._onClickAlert.bind(this)}
        />
      </div>
    )
  }

  _renderMessage () {
    if (!this.state.isLoading && !this.data?.invoiceTemplates?.length) {
      return (
        <ContentMessage
          message='invoicetemplate.list.emptyInvoiceTemplate'
          info='invoicetemplate.list.contentInfo'
          showAddPrefix
          showAdd
          onAdd={this.onAdd.bind(this)}
        />
      )
    }

    return null
  }

  _onSubmitMail (mailObj) {
    this.setState({ isLoading: true })

    if (this.data.currTemplate) {
      app.debug('PageInvoiceTemplate: _onSubmitMail [Start]')
      const updateObj = {
        contactPerson: mailObj.contactPerson,
        contactAddress: mailObj.contactAddress,
        referenceNo: mailObj.referenceNo,
        mailSetting: {
          toEmails: mailObj.toEmails
        }
      }

      app
        .service('/api/invoice/template')
        .patch(this.data.currTemplate.id, updateObj, {})
        .then(_result => {
          if (this._references.refdialogMailSetting.current) {
            this._references.refdialogMailSetting.current.hide()
          }
          this._activeInvoiceTemplate(this.data.currTemplate)
          this.data.currTemplate = null
          this.setState({ isLoading: false })
        })
        .catch(err => {
          app.debug('PageInvoiceView: _onSubmitMail err', err)
        })
    }
  }

  _onCloseDialog () {
    if (this._references.templateSettingDialog.current) {
      this._references.templateSettingDialog.current.hide()
    }
  }

  _renderSettingsDialog () {
    const { isLoading } = this.state
    const currTemplate = this.data.currTemplate

    if (isLoading || !currTemplate) {
      return null
    }

    const bCanStart = !currTemplate.isActive
    const bCanComplete = !!(
      currTemplate.isActive &&
      !currTemplate.isCompleted &&
      !currTemplate.isCanceled
    )
    const editBtnClss = !currTemplate.isActive
      ? 'action-btn'
      : 'action-btn disable'

    return (
      <DialogSetting ref={this._references.templateSettingDialog}>
        <div className='actionboard-row act-row'>
          {!currTemplate.isActive && (
            <div className='actionboard-col2 alert-col2'>
              <div
                className={editBtnClss}
                onClick={
                  !currTemplate.isActive
                    ? this._onEdit.bind(this, currTemplate)
                    : null
                }
              >
                <Button
                  icon='action-edit'
                  className='button_dialog'
                  canHover={false}
                />
                <span className='label'>
                  <IntlMessage ident='setting.userList.actionEdit' />
                </span>
              </div>
            </div>
          )}
          {bCanStart && (
            <div className='actionboard-col2 alert-col2'>
              <div
                className='action-btn'
                onClick={this._onStart.bind(this, currTemplate)}
              >
                <Button
                  icon='action-start'
                  className='button_dialog'
                  canHover={false}
                />
                <span className='label'>
                  <IntlMessage ident='invoicetemplate.view.start' />
                </span>
              </div>
            </div>
          )}
          {bCanComplete && (
            <div className='actionboard-col2 alert-col2'>
              <div
                className='action-btn'
                onClick={this._onComplete.bind(this, currTemplate)}
              >
                <Button
                  icon='action-stop'
                  className='button_dialog'
                  canHover={false}
                />
                <span className='label'>
                  <IntlMessage ident='invoicetemplate.view.stop' />
                </span>
              </div>
            </div>
          )}
        </div>
        <ConfirmDelete
          ref={this._references.confirmStop}
          title='project.list.msgConfirmDelete'
          onClickOk={this._onClickStopConfirm.bind(this, currTemplate)}
        />
      </DialogSetting>
    )
  }

  _validateStartDate (startDate) {
    const currDate = new Date()
    const dueDateTimeStamp = new Date(startDate).getTime()
    const invoiceDateTimeStamp = new Date(currDate).getTime()

    if (util.isDateEqual(new Date(startDate), new Date(currDate))) {
      return false
    }

    if (dueDateTimeStamp < invoiceDateTimeStamp) {
      return true
    }

    return false
  }

  _showEmailDialog (bShowErr) {
    const invoicetemplate = _.cloneDeep(this.data.currTemplate)
    const contact = invoicetemplate.contact
    const contactAddresses =
      invoicetemplate &&
      invoicetemplate.contact &&
      invoicetemplate.contact.addresses
        ? invoicetemplate.contact.addresses
        : null

    invoicetemplate.contactPersonOptions = this._getContactPersonOptions(
      contact
    )
    invoicetemplate.addressOptions = this._getContactAddressOptions(
      invoicetemplate
    )
    invoicetemplate.addresses = contactAddresses
    invoicetemplate.contactAddress =
      invoicetemplate.contactAddress && invoicetemplate.contactAddress.type
        ? invoicetemplate.contactAddress
        : contactAddresses
        ? contactAddresses[0]
        : null
    if (this._references.refdialogMailSetting.current) {
      this._onCloseDialog()
      this._references.refdialogMailSetting.current.show(
        invoicetemplate,
        bShowErr
      )
    }
  }

  _getContactPersonOptions (contact) {
    const contactPersonOptions = []
    if (
      contact &&
      contact.contactPersons &&
      contact.contactPersons.length > 0
    ) {
      contact.contactPersons.map(contactPerson => {
        const label =
          contactPerson.name +
          (contactPerson.email ? ' - ' + contactPerson.email : '')
        contactPersonOptions.push({
          label: label,
          value: label,
          obj: contactPerson
        })
      })
    }

    return contactPersonOptions
  }

  _getContactAddressOptions (invoiceTemplate) {
    const addressOptions = []
    const contact = invoiceTemplate.contact
    if (contact && contact.addresses && contact.addresses.length > 0) {
      contact.addresses.map(address => {
        const existTypeOption = _.find(
          addressOptions,
          addressOption => addressOption.label === address.type
        )
        const label = IntlUtil.convertMessage(
          `contact.view.type${address.type}`
        )
        if (existTypeOption === undefined) {
          addressOptions.push({
            label: label,
            value: address.type.toLowerCase()
          })
        }
      })
    }

    if (
      invoiceTemplate.contactAddress &&
      addressOptions[0].value === undefined
    ) {
      const label = IntlUtil.convertMessage(
        `contact.view.type${invoiceTemplate.contactAddress.type}`
      )
      addressOptions.push({
        label: label,
        value: invoiceTemplate.contactAddress.type.toLowerCase()
      })
    }

    return addressOptions
  }

  _onStart (invoiceTemplate) {
    let noErrors = 0

    if (this._validateStartDate(invoiceTemplate.startDate)) {
      if (this._references.dialogInvoiceTemplate.current) {
        this._references.dialogInvoiceTemplate.current.show(
          invoiceTemplate,
          true
        )
      }
      noErrors++
    } else if (
      invoiceTemplate.mailSetting === null ||
      invoiceTemplate.mailSetting.toEmails === undefined ||
      invoiceTemplate.mailSetting.toEmails.length === 0
    ) {
      this._showEmailDialog(true)
      noErrors++
    }

    if (noErrors === 0) {
      this._activeInvoiceTemplate(invoiceTemplate)
    }
  }

  _activeInvoiceTemplate (invoiceTemplate) {
    app
      .service('/api/invoice/template')
      .patch(invoiceTemplate.id, { isActive: true })
      .then(_updateRes => {
        this._reloadData()
      })
      .catch(updateErr => {
        app.debug('PageInvoiceTemplate: _onStart err', updateErr)
      })
  }

  _onComplete (invoiceTemplate, e) {
    e.preventDefault()
    if (this._references.confirmStop.current) {
      this._references.confirmStop.current.show()
    }
  }

  _onClickStopConfirm (invoiceTemplate) {
    app
      .service('/api/invoice/template')
      .patch(invoiceTemplate.id, { isCanceled: true })
      .then(_updateRes => {
        this._reloadData()
        if (this._references.templateSettingDialog.current) {
          this._references.templateSettingDialog.current.hide()
        }
        if (this._references.confirmStop.current) {
          this._references.confirmStop.current.hide()
        }
      })
      .catch(updateErr => {
        app.debug('PageInvoiceTemplate: _onComplete err', updateErr)
      })
  }

  _onEdit (invoiceTemplate) {
    if (invoiceTemplate && this._references.dialogInvoiceTemplate.current) {
      this._references.dialogInvoiceTemplate.current.show(invoiceTemplate)
    }
  }

  getContentClassname () {
    return this.data.pageState.type === 'grid' ? 'alt' : null
  }

  onAdd () {
    if (this._references.dialogInvoiceTemplate.current) {
      this._references.dialogInvoiceTemplate.current.show()
    }
  }

  /* Private functions */
  _renderGridOrList () {
    if (this.state.isLoading || !this.data.invoiceTemplates.length) {
      return null
    }

    let bShowLoader = false
    const invoiceTemplates = this.data.invoiceTemplates
    if (invoiceTemplates && invoiceTemplates.length < this.data.total) {
      bShowLoader = true
    }

    return (
      <div className='gridwrap'>
        <Grid
          objectList={this.data.invoiceTemplates}
          sortOptions={this._getSortOptions()}
          onPaginate={this._onPaginate.bind(this)}
          sort={this.data.pageState.sort}
          sortAsc={this.data.pageState.sortAsc}
          showLoader={bShowLoader}
          onSort={this._onSort.bind(this)}
          onRenderGrid={this._onRenderGrid.bind(this)}
        />
      </div>
    )
  }

  _getSortOptions () {
    return [
      { label: 'invoicetemplate.list.createdOn', value: 'nextRecurringDate' },
      { label: 'invoicetemplate.list.interval', value: 'interval' },
      { label: 'invoicetemplate.list.type', value: 'type' }
    ]
  }

  _onPaginate () {
    if (this.data.canPaginate) {
      const page = this.data.pageNo + 1
      this.data.pageNo = page
      this._reloadData()
    }
  }

  _onSort (sort, sortAsc) {
    this.data.pageState.sort = sort
    this.data.pageState.sortAsc = sortAsc
    this.data.pageNo = 1
    this._reloadData()
  }

  _onRenderGrid (invoiceTemplate) {
    const appTeam = app.getTeam()
    const defaultPaymentDays =
      appTeam && appTeam.profile ? appTeam.profile.payPeriod : 0

    return (
      <InvoiceTemplateItem
        invoiceTemplate={invoiceTemplate}
        key={invoiceTemplate.id}
        isQuickbookConnected={app.isQuickbookConnected()}
        showProjectNumber={app.projectSetting.useProjectNo}
        onView={this._onGridItemClick.bind(this, invoiceTemplate)}
        teamPaymentPeriod={defaultPaymentDays}
        onSetting={this._onClickSetting.bind(this)}
        onSubView={this._onSubView.bind(this)}
      />
    )
  }

  _onGridItemClick (invoiceTemplate) {
    if (invoiceTemplate) {
      app.changePage('invoice-template-view', invoiceTemplate.id)
    }
  }

  _onSubView (invoiceId) {
    if (invoiceId) {
      app.changePage('invoice-view', invoiceId)
    }
  }

  _onClickSetting (invoiceTemplate) {
    if (invoiceTemplate) {
      this.data.currTemplate = invoiceTemplate
      this.data.showSettings = true

      this.setState({ dataDate: new Date() })
    }
  }

  _triggerSettingsDialog () {
    if (this.data.showSettings) {
      this.data.showSettings = false

      if (this.data.currTemplate) {
        const invoiceTemplate = this.data.currTemplate
        const contactName = invoiceTemplate.contact
          ? invoiceTemplate.contact.company
          : ''
        const projectName = invoiceTemplate.project
          ? invoiceTemplate.project.title
          : ''
        if (this._references.templateSettingDialog.current) {
          this._references.templateSettingDialog.current.show(
            projectName,
            contactName,
            null,
            null
          )
        }
      }
    }
  }

  /* Event handlers */
  _onChangePage (pageIdent) {
    app.changePage(pageIdent)
  }

  _onFilter (filter) {
    this.data.pageState.filter = filter

    if (filter.contentType !== this.data.pageState.type) {
      this.data.pageState.type = filter.contentType
      this.forceUpdate()
      this._updatePageState(this.data.pageState)
    } else {
      this.data.pageNo = 1
      this._reloadData()
    }
  }

  _onCloseFilter () {
    this.data.pageState.filter.contact = null
    this.data.pageState.filter.period = null
    this.data.pageState.filter.status = null
    this._reloadData()
  }

  _onClickAlert (_ev) {
    app.changePage('setting-companyprofile')
  }

  _onSearchContact (keyword, callback) {
    this._onCommonFilterContactSearch(keyword, callback)
  }

  _onSearchProject (keyword, callback) {
    this._onCommonFilterProjectSearch(keyword, false, callback)
  }

  _getData (bReload) {
    const skip = (this.data.pageNo - 1) * 20
    const params = {
      query: {
        bUpdatePageState: bReload,
        pageState: this.data.pageState,
        pageIdent: this._pageIdent,
        invoiceTemplate: {
          $limit: 20,
          $skip: skip,
          $client: {
            subObjects: {
              contact: [
                'company',
                'image',
                'imageUrl',
                'paymentDays',
                'addresses',
                'contactPersons'
              ],
              project: ['title', 'projectNumber']
            }
          }
        }
      }
    }

    app
      .service('/api/page/invoicetemplate')
      .find(params)
      .then(result => {
        if (result) {
          this._onPageDataRecieved(result.pageData)

          if (result.stat) {
            this.data.stat = result.stat
          }
          if (result.invoiceTemplateResult) {
            this._processSorting(result.invoiceTemplateResult, params)
          }
          if (result.companyFields) {
            this.data.companyFields = result.companyFields
          }
          this._onDataReceived(null)
        }
      })
      .catch(err => {
        this._onDataReceived(err)
      })
  }

  _onUserStateRecieved (userState) {
    const pageState = this._getPageUserState(userState)
    if (pageState) {
      this.data.pageState = {
        sort: pageState.sort || 'nextRecurringDate',
        sortAsc: pageState.sortAsc !== undefined ? pageState.sortAsc : true,
        type: pageState.type || 'grid',
        filter: pageState.filter || null
      }
    }
  }

  _processSorting (invoiceTempRes, params) {
    if (invoiceTempRes.data && this.data.pageState.sort) {
      invoiceTempRes.data = _.sortBy(
        invoiceTempRes.data,
        this.data.pageState.sort
      )
      if (!this.data.pageState.sortAsc) {
        invoiceTempRes.data.reverse()
      }
    }

    this.data.invoiceTemplates =
      this.data.pageNo > 1
        ? this.data.invoiceTemplates.concat(invoiceTempRes.data)
        : invoiceTempRes.data

    this.data.total = invoiceTempRes.total
    this.data.countLoaded = params.query.$limit * this.data.pageNo
    this.data.canPaginate = !(this.data.countLoaded > this.data.total)
  }

  _onDataReceived (err) {
    if (this._bUnMounted) return

    if (err) {
      app.debug('PageInvoiceTemplate: _onDataReceived Error', err)
      this._setFABButtonVisible(false)
    } else {
      app.debug('PageInvoiceTemplate: _onDataReceived [done]')
      if (this.data.invoiceTemplates && this.data.invoiceTemplates.length > 0) {
        this._setFABButtonVisible(true)
      } else {
        this._setFABButtonVisible(false)
      }

      if (
        this.data.companyFields.length > 0 &&
        this.state.showDataAlert &&
        this._references.popupcompanyprofiledata.current
      ) {
        this._references.popupcompanyprofiledata.current.show()
      }

      this.setState({
        isLoading: !(
          this.data.invoiceTemplates && this.data.invoiceTemplates.length > 0
        ),
        showDataAlert: false
      })
    }
    this.setState({ isLoading: false, dataDate: new Date() })
  }

  _reloadData () {
    this._getData(true)
  }

  _onAddTemplateInvoice (templateObj, templateId) {
    if (templateId) {
      this._updateTemplateInvoice(templateObj, templateId)
    } else {
      this._createTemplateInvoice(templateObj)
    }
  }

  _createTemplateInvoice (templateObj) {
    const params = {
      query: {
        $client: {
          firstPeriodDate: {
            year: templateObj.firstPeriodDate.getFullYear(),
            month: templateObj.firstPeriodDate.getMonth(),
            date: templateObj.firstPeriodDate.getDate()
          },
          startDate: {
            year: templateObj.startDate.getFullYear(),
            month: templateObj.startDate.getMonth(),
            date: templateObj.startDate.getDate()
          }
        }
      }
    }

    delete templateObj.firstPeriodDate
    delete templateObj.startDate
    delete templateObj.endDate

    templateObj.createdById = app.loggedInId
    app
      .service('/api/invoice/template')
      .create(templateObj, params)
      .then(tempRes => {
        if (tempRes) {
          if (this._references.dialogInvoiceTemplate.current) {
            this._references.dialogInvoiceTemplate.current.hide()
          }
          app.changePage('invoice-template-view', tempRes.id)
        }
      })
      .catch(prjErr => {
        app.debug('PageInvoiceTemplate: _createTemplateInvoice Error', prjErr)
      })
  }

  _updateTemplateInvoice (templateObj, templateId) {
    const params = {
      query: {
        $client: {
          firstPeriodDate: {
            year: templateObj.firstPeriodDate.getFullYear(),
            month: templateObj.firstPeriodDate.getMonth(),
            date: templateObj.firstPeriodDate.getDate()
          },
          startDate: {
            year: templateObj.startDate.getFullYear(),
            month: templateObj.startDate.getMonth(),
            date: templateObj.startDate.getDate()
          }
        }
      }
    }

    delete templateObj.firstPeriodDate
    delete templateObj.startDate
    delete templateObj.endDate

    app
      .service('/api/invoice/template')
      .patch(templateId, templateObj, params)
      .then(_templateObj => {
        if (this._references.dialogInvoiceTemplate.current) {
          this._references.dialogInvoiceTemplate.current.hide()
        }

        if (this._references.templateSettingDialog.current) {
          this._references.templateSettingDialog.current.hide()
        }
      })
      .catch(_prjErr => {
        this.showError('invoicetemplate.list.msgErrorUpdateTemplateObj')
      })
  }

  _onDelete (invoiceTemplateId) {
    if (!invoiceTemplateId) {
      return false
    }

    app
      .service('/api/invoice/template')
      .remove(invoiceTemplateId)
      .then(_deleteRes => {
        if (this._references.dialogInvoiceTemplate.current) {
          this._references.dialogInvoiceTemplate.current.hide()
        }
        this._onCloseDialog()
        this.data.pageNo = 1
        this._reloadData()
      })
      .catch(deleteErr => {
        app.debug('PageInvoiceTemplate delete err', deleteErr)
      })
  }

  /* Realtime Events */
  _initEvents () {
    this._eventHandlers.invoiceTemplateCreated = this._eventReload.bind(
      this,
      'InvoiceTemplate',
      'Created'
    )
    this._eventHandlers.invoiceTemplateUpdated = this._eventReload.bind(
      this,
      'InvoiceTemplate',
      'Updated'
    )
    this._eventHandlers.invoiceTemplateRemoved = this._eventReload.bind(
      this,
      'InvoiceTemplate',
      'Removed'
    )
    this._eventHandlers.invoiceTemplatePatched = this._eventReload.bind(
      this,
      'InvoiceTemplate',
      'Patched'
    )

    const invoiceTemplateService = app.service('/api/invoice/template')
    invoiceTemplateService.on(
      'created',
      this._eventHandlers.invoiceTemplateCreated
    )
    invoiceTemplateService.on(
      'updated',
      this._eventHandlers.invoiceTemplateUpdated
    )
    invoiceTemplateService.on(
      'removed',
      this._eventHandlers.invoiceTemplateRemoved
    )
    invoiceTemplateService.on(
      'patched',
      this._eventHandlers.invoiceTemplatePatched
    )
  }

  _releaseEvents () {
    const invoiceTemplateService = app.service('/api/invoice/template')
    invoiceTemplateService.off(
      'created',
      this._eventHandlers.invoiceTemplateCreated
    )
    invoiceTemplateService.off(
      'updated',
      this._eventHandlers.invoiceTemplateUpdated
    )
    invoiceTemplateService.off(
      'removed',
      this._eventHandlers.invoiceTemplateRemoved
    )
    invoiceTemplateService.off(
      'patched',
      this._eventHandlers.invoiceTemplatePatched
    )

    this._eventHandlers.invoiceTemplateService = null
    this._eventHandlers.invoiceTemplateService = null
    this._eventHandlers.invoiceTemplateService = null
    this._eventHandlers.invoiceTemplateService = null
  }

  _eventReload (objectName, eventName, eventData) {
    if (eventfilters.teamFilter(eventData)) {
      app.debug(
        `-- Event - PageInvoiceTemplate - ${objectName} - ${eventName} --`
      )
      this.data.pageNo = 1
      this._reloadData()
    }
  }

  /* Header Functions - START */
  renderHeader () {
    const { stat, pageState } = this.data
    const filter = pageState.filter || {}

    const filters = [
      {
        ident: 'status',
        type: 'option',
        label: 'invoicetemplate.list.filterLabelActive',
        options: [
          { label: 'invoicetemplate.list.filterLabelAll', ident: 'all' },
          { label: 'invoicetemplate.list.filterLabelActive', ident: 'Active' },
          {
            label: 'invoicetemplate.list.filterLabelFinalised',
            ident: 'Finalised'
          }
        ],
        isMulti: false,
        value: filter.status || '',
        defaultValue: 'Active'
      },
      {
        type: 'label',
        label: 'invoicetemplate.list.filterTemplateFor'
      },
      {
        ident: 'contact',
        type: 'tag',
        label: 'invoicetemplate.list.filterLabelClient',
        placeholder: 'estimate.list.searchClientPlaceholder',
        isMulti: false,
        value: filter.contact || null
      },
      {
        type: 'label',
        label: 'invoicetemplate.list.filterLabelAnd'
      },
      {
        ident: 'period',
        type: 'option',
        label: 'invoice.list.filterAllPeriods',
        options: [
          { label: 'invoicetemplate.list.filterLabelAll', ident: 'all' },
          { label: 'invoicetemplate.list.filterLabelWeekly', ident: 'weekly' },
          {
            label: 'invoicetemplate.list.filterLabelMonthly',
            ident: 'monthly'
          },
          {
            label: 'invoicetemplate.list.filterLabelQuaterly',
            ident: 'quaterly'
          },
          { label: 'invoicetemplate.list.filterLabelYearly', ident: 'yearly' }
        ],
        isMulti: false,
        defaultValue: 'all',
        value: filter.period || null
      }
    ]

    const statInfos = [
      {
        title: 'invoicetemplate.view.invoiceTemplatePriceInfo',
        value: stat ? stat.totalUnpaid : 0,
        isPrice: true
      }
    ]

    return (
      <PageHeader
        ref={this._references.refHeaderInvoiceTemplate}
        title='invoicetemplate.list.titleInvoiceTemplate'
        icon={<InvoicesIcon width={25} />}
        hasFilter
        showTabs
        activeTab='invoice-template'
        favoriteTab={this._getUserFavoriteTab('invoice') || 'invoices'}
        tabs={[
          {
            ident: 'invoices',
            title: 'invoicetemplate.list.invoices',
            showFavourite: true
          },
          {
            ident: 'invoice-template',
            title: 'invoicetemplate.list.invoicetemplates',
            showFavourite: true
          }
        ]}
        filters={filters}
        statInfos={statInfos}
        keywordSearch={filter.keyword}
        onChange={this._onHeaderChangeFilter.bind(this)}
        onSearchTags={this._onHeaderSearchTags.bind(this)}
        onTabChange={this._onHeaderTabChange.bind(this)}
        onToggleFavorite={this._onHeaderToggleFavorite.bind(this)}
      />
    )
  }

  _onHeaderTabChange (tab) {
    app.changePage(tab.ident)
  }

  _onHeaderChangeFilter (filter) {
    this.data.pageState.filter = filter
    this.data.pageNo = 1

    this._reloadData()
  }

  _onHeaderSearchTags (filterIdent, keyword, callback) {
    if (filterIdent === 'project') {
      this._onCommonFilterProjectSearch(keyword, false, callback)
    } else if (filterIdent === 'contact') {
      this._onCommonFilterContactSearch(keyword, callback)
    }
  }

  _onHeaderToggleFavorite (tab) {
    this._updateUserStateFavorite('invoice', tab.ident)
    this.setState({ dataDate: new Date() })
  }

  /* Header Functions - END */
}

export default PageInvoiceTemplate
